//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        min: {
            type: Number,
            required: true,
        },
        max: {
            type: Number,
            required: true,
        },
        onMax: {
            type: String,
            required: false,
            default: '',
        },
        step: {
            type: Number,
            required: false,
            default: 1,
        }
    },
    computed: {
        computedMax()
        {
            if ( this.onMax !== '' && this.value >= this.max ) {
                return this.onMax;
            }

            return this.value;
        }
    },
    methods: {
        handleInput()
        {
            this.$refs.input.style.setProperty('--val', this.$refs.input.value );

            this.$emit('input', parseInt( this.$refs.input.value ) );
            this.$emit('change', parseInt( this.$refs.input.value ) );
        }
    },
}
